import { ChatMessage } from "shared";
import styled from "styled-components";

export const Message = styled(ChatMessage)`
  background-color: ${(props) => props.theme.colors.opacityGrey5};
  margin-bottom: 8px;
  max-width: 278px;
  margin-left: 16px;
`;
